import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import { useDispatch, useSelector } from 'react-redux'
import { agregarPagoLiq } from "../../../redux/datosPagoSinFacturaSlice"
import { Boton, Input, InputDate, Label } from 'asocomponents'
import SelectConcepto from '../Selects/SelectConcepto/SelectConcepto'
import FormasPago from './FormasDePago'
import { formatearNumero } from '../../../helpers/funciones'
import { mostrarMensaje } from '../../../helpers/mensajeria'
import { MENSAJESAPP } from "../../../const/constantes.js";

Modal.setAppElement('#root'); // Asegurate de tener un #root en index.html

export default function ModalAgregarPago({ isOpen, onClose, idKey }) {
    const dispatch = useDispatch();
    const pagoSinFactura = useSelector((state) => state.rootReducer.datosPagoSinFactura.pagoSinFactura)

    const [tempFecha, setTempFecha] = useState()
    const [tempIdConcepto, setTempIdConcepto] = useState()
    const [tempConcepto, setTempConcepto] = useState('')
    const [tempImporte, setTempImporte] = useState()

    const [tempFormaPago, setTempFormaPago] = useState()
    const [descripcionFormasPago, setDescripcionFormasPago] = useState()
    const [descripcionSubFormasPago, setDescripcionSubFormasPago] = useState()
    const [descripcion1Pago, setDescripcion1Pago] = useState()
    const [descripcion2Pago, setDescripcion2Pago] = useState()

    const [arrayConceptos, setArrayConceptos] = useState()

    const [error, setError] = useState('')

    const reset = () => {
        setTempFecha(null);
        setTempIdConcepto(-2)
        setTempConcepto('')
        setTempImporte()
        setError('')
        setTempFormaPago()
        setArrayConceptos([])
    }

    const handleConcepto = (event) => {
        const valor = event.target;
        setTempIdConcepto(parseInt(valor.value));
        setTempConcepto(valor.options[valor.selectedIndex].text);
    }

    const handleAgregarConcepto = () => {
        if (!tempIdConcepto || tempIdConcepto === -1 || !tempConcepto || !tempImporte) {
            setError(MENSAJESAPP.VALIDACIONES.CONCEPTOIMPORTE);
            return
        }

        const importeTotal = parseFloat(arrayConceptos.reduce((suma, item) => suma + item.importe, 0)) + parseFloat(tempImporte)

        if (importeTotal > 99999999) {
            setError(MENSAJESAPP.VALIDACIONES.MONTOMAXIMOPAGO);
            return
        }

        const existeConcepto = arrayConceptos.some(c => c.idconcepto === tempIdConcepto)

        if (existeConcepto) {
            mostrarMensaje(MENSAJESAPP.ERRORES.CONCEPTOYAEXISTENTE, "error", 2000)
        }
        else {
            const nuevoConcepto = {
                idKey: Date.now(),
                idconcepto: tempIdConcepto,
                concepto: tempConcepto,
                importe: parseFloat(tempImporte)
            }

            setArrayConceptos(prev => [...prev, nuevoConcepto])

            setTempIdConcepto(-2)
            setTempConcepto('')
            setTempImporte(0)
            setError('')
        }
    };

    const handleAgregarPago = () => {
        const hoy = new Date()
        hoy.setHours(0, 0, 0, 0)

        if (!tempFecha || new Date(tempFecha) <= hoy) {
            setError(MENSAJESAPP.VALIDACIONES.FECHAVTO)
            return
        }

        if (!tempFormaPago || !tempFormaPago.forma || Object.keys(tempFormaPago.errores || {}).length > 0) {
            setError(MENSAJESAPP.VALIDACIONES.DATOSINCOMPLETOSFORMAPAGO)
            return
        }

        if (arrayConceptos.length === 0) {
            setError(MENSAJESAPP.ERRORES.CONCEPTOSNOEXISTENTES)
            return
        }

        const importeTotal = arrayConceptos.reduce((suma, item) => suma + item.importe, 0)

        dispatch(agregarPagoLiq({
            fechaVto: tempFecha,
            formaPago: tempFormaPago,
            importeTotal,
            conceptosLiq: arrayConceptos
        }))

        reset()
        onClose()
    }

    const eliminarConcepto = (id) => {
        setArrayConceptos(arrayConceptos.filter(c => c.idKey !== id))
    }

    const cargarDatosPago = () => {

        const pago = pagoSinFactura.pagos.find(c => c.idKey === idKey)

        if (pago) {
            setTempFecha(pago.fechaVto)
            setDescripcionFormasPago(pago?.formaPago?.forma?.label ?? '')
            setDescripcionSubFormasPago(pago?.formaPago?.subforma?.label ?? '')
            setDescripcion1Pago(pago?.formaPago?.descripcionPago1)
            setDescripcion2Pago(pago?.formaPago?.descripcionPago2)
            setArrayConceptos(pago?.conceptosLiq)
        }
    }

    useEffect(() => {
        if (!isOpen) {
            reset()
            return
        }

        if (isOpen && idKey && pagoSinFactura?.pagos?.length > 0) {
            cargarDatosPago()
        } else if (pagoSinFactura.fechaVto) {
            setTempFecha(pagoSinFactura.fechaVto)
            setArrayConceptos([])
        }

    }, [isOpen, idKey])

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Agregar Pago"
            className="bg-white p-6 rounded-lg w-[950px] max-w-full mx-auto mt-10 outline-none"
            overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start z-50"
        >
            <div className={`max-h-[80vh] overflow-y-auto  ${!idKey ? '' : 'pointer-events-none'}`} >
                <h2 className="text-xl font-bold mb-4 text-center">AGREGAR UN NUEVO PAGO</h2>
                <div className='flex flex-col text-xs font-semibold mb-5 text-center'>
                    Para agregar un nuevo pago, asegúrese de completar todos los campos del formulario.
                </div>

                <div className="flex flex-row items-center gap-3 mb-5">
                    <Label texto="Fecha de Vencimiento:" />
                    <InputDate width="w-40" onChange={setTempFecha} valor={tempFecha} disabledSabDom={true} />
                </div>

                <div className="flex flex-row mb-5">
                    <Label texto="Forma de Pago:" />
                    {idKey ?
                        <div className='flex flex-row justify-around'>
                            <Label texto={descripcionFormasPago} />
                            <Label texto={descripcionSubFormasPago} />
                            <Label texto={descripcion1Pago} />
                            <Label texto={descripcion2Pago} />
                        </div>
                        :
                        <FormasPago onCambioFormaPago={(valorFormaPagoSelec) => { setTempFormaPago(valorFormaPagoSelec) }} />
                    }
                </div>

                <hr className="mb-5" />

                {!idKey && <div className="flex flex-row gap-4 items-center mb-5">
                    <div className="flex flex-row gap-2 items-center">
                        <Label texto="Concepto:" />
                        <SelectConcepto width="w-44" valor={tempIdConcepto} onChange={handleConcepto} />
                    </div>

                    <div className="flex flex-row gap-2 items-center">
                        <Label texto="Importe:" />
                        <Input
                            type="number"
                            alt="Importe"
                            onChange={(dato) => setTempImporte(dato)}
                            valor={tempImporte}
                            width="w-24"
                            labelNumber={true}
                        />
                    </div>

                    <Boton icono="add" fondo="rojo" height="h-7" alt="Agregar Concepto" onClick={handleAgregarConcepto} />
                </div>
                }
                {error && <div className="text-red-500 text-xs mb-4">{error}</div>}

                <div className="mb-5">
                    <table className="table-fixed text-xs text-left text-gray-500 w-full">
                        <thead className="text-[0.6rem] text-gray-700 uppercase bg-gray-200">
                            <tr>
                                <th className="text-center py-1 w-[35%]">Concepto</th>
                                <th className="text-center py-1 w-[10%]">Importe</th>
                                <th className="text-center py-1 w-[7%]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {arrayConceptos?.map((item) => (
                                <tr key={item.idKey} className="bg-white border-b hover:bg-gray-50">
                                    <td className="text-center">{item.concepto}</td>
                                    <td className="text-center">$ {formatearNumero(item.importe)}</td>
                                    <td className="text-center">
                                        <Boton
                                            icono="eliminar"
                                            width="w-2"
                                            onClick={() => eliminarConcepto(item.idKey)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="flex justify-end items-center gap-3 mt-6">
                <button className="bg-gray-400 text-white px-4 py-2 rounded" onClick={onClose}>Cancelar</button>
                {!idKey && <button className="bg-rose-600 text-white px-4 py-2 rounded" onClick={handleAgregarPago}>Agregar</button>}
            </div>
        </Modal>
    );
}
